import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { withTheme } from 'styled-components';
import { getColumnsWidthForBreakpoint, getGridColumn } from '../helpers/grid';
import { Breakpoints } from '../helpers/breakpoint';
import { css, styled } from '../theme-provider';
import { getCommonProps } from '../helpers/common-props';
const animationClassName = 'animation';
const animationTimeout = (props) => props.theme.animation.duration.layer;
const animationTimingFunction = (props) => props.theme.animation.timingFunction.in;
const baseTransform = 'translate(-50%, -50%)';
function calcLayerHeight(spacing) {
    return `calc(100% - ${spacing} * 2);`;
}
const StyledLayer = styled.div.withConfig({ displayName: "StyledLayer", componentId: "sc-ku0g94" }) `position:absolute;top:50%;left:50%;overflow-y:auto;-webkit-overflow-scrolling:touch;${(props) => css `
		max-height: ${calcLayerHeight(props.theme.size.static200)};

		@media (min-width: ${Breakpoints.b560}px) {
			max-height: ${calcLayerHeight(props.theme.size.static300)};
		}

		@media (min-width: ${Breakpoints.b1600}px) {
			max-height: ${calcLayerHeight(props.theme.size.static400)};
		}

		@media (min-width: ${Breakpoints.b2560}px) {
			max-height: ${calcLayerHeight(props.theme.size.static510)};
		}

		${props.size === 'A' &&
    `width: ${getGridColumn(22)};

			@media (min-width: ${Breakpoints.b560}px) {
				width: ${getGridColumn(20)};
			}

			@media (min-width: ${Breakpoints.b960}px) {
				width: ${getGridColumn(16)};
			}

			@media (min-width: ${Breakpoints.b1280}px) {
				width: ${getGridColumn(14)};
			}

			@media (min-width: ${Breakpoints.b1600}px) {
				width: ${getGridColumn(12)};
			}

			@media (min-width: ${Breakpoints.b1920}px) {
				width: ${getGridColumn(10)};
			}

			@media (min-width: ${Breakpoints.b2560}px) {
				width: ${getColumnsWidthForBreakpoint(10, Breakpoints.b2560)};
			}`}
		${props.size === 'B' &&
    `width: ${getGridColumn(22)};

			@media (min-width: ${Breakpoints.b560}px) {
				width: ${getGridColumn(20)};
			}

			@media (min-width: ${Breakpoints.b960}px) {
				width: ${getGridColumn(16)};
			}

			@media (min-width: ${Breakpoints.b1600}px) {
				width: ${getGridColumn(14)};
			}

			@media (min-width: ${Breakpoints.b1920}px) {
				width: ${getGridColumn(12)};
			}

			@media (min-width: ${Breakpoints.b2560}px) {
				width: ${getColumnsWidthForBreakpoint(12, Breakpoints.b2560)};
			}`}
		${props.size === 'C' &&
    `width: ${getGridColumn(24)};
		// layer size will be used with 16/9 images + navigation elements in it
		// therefore we try to maintain a roughly fitting aspect ratio for the layer
		max-width: 135vh;

			@media (min-width: ${Breakpoints.b1280}px) {
				width: ${getGridColumn(22)};
			}

			@media (min-width: ${Breakpoints.b1920}px) {
				width: ${getGridColumn(20)};
			}`}
	`} background-color:${(props) => props.theme.colors.background.primary};opacity:1;transform:${baseTransform} translateY(0);transition:opacity ${(props) => animationTimeout(props)} ${(props) => animationTimingFunction(props)},transform ${(props) => animationTimeout(props)} ${(props) => animationTimingFunction(props)};&.${animationClassName}-exit{opacity:1;transform:${baseTransform} translateY(0);}&.${animationClassName}-enter,&.${animationClassName}-exit-active,&.${animationClassName}-exit-done{opacity:0;transform:${baseTransform} translateY(${(props) => props.theme.size.static500});}&.${animationClassName}-enter-active{opacity:1;transform:${baseTransform} translateY(0);}`;
const InternalFocusLayer = (props) => {
    const { active, ariaLabel, ariaDescribedBy, ariaLabelledBy, children, in: visible, onExited, size, scrollElementRef, } = props;
    const commonProps = getCommonProps(props);
    return (React.createElement(CSSTransition, { classNames: animationClassName, onExited: onExited, in: visible, timeout: parseInt(animationTimeout(props) || '0', 10) },
        React.createElement(StyledLayer, Object.assign({ role: "dialog", "aria-modal": active, "aria-describedby": ariaDescribedBy, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, size: size, ref: scrollElementRef }, commonProps), children)));
};
export const FocusLayer = withTheme(InternalFocusLayer);
